module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "toolbar-general"
  }, [(_vm.transparentToolbar) ? _c('div', {
    staticClass: "opacity-div"
  }) : _vm._e(), _vm._v(" "), _c('v-app-bar', {
    staticClass: "Toolbar white px-0",
    attrs: {
      "id": "toolbar",
      "app": ""
    }
  }, [(_vm.dialMenu) ? _c('div', {
    staticClass: "transparent-div"
  }) : _vm._e(), _vm._v(" "), _c('v-speed-dial', {
    staticClass: "speed-dial",
    attrs: {
      "direction": "bottom",
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c('v-btn', {
          class: ("ma-0 my-3 " + (_vm.dialMenu ? 'dial-menu-btn-active' : '')),
          attrs: {
            "color": "black",
            "small": "",
            "fab": "",
            "text": "",
            "id": "btnDialMenu"
          },
          on: {
            "click": function($event) {
              return _vm.toggleMenu(_vm.dialMenu)
            }
          },
          model: {
            value: (_vm.dialMenu),
            callback: function($$v) {
              _vm.dialMenu = $$v
            },
            expression: "dialMenu"
          }
        }, [(_vm.dialMenu) ? _c('v-icon', [_vm._v("close")]) : _c('v-icon', [_vm._v("menu")])], 1)]
      },
      proxy: true
    }], null, false, 1483797131),
    model: {
      value: (_vm.dialMenu),
      callback: function($$v) {
        _vm.dialMenu = $$v
      },
      expression: "dialMenu"
    }
  }, [_vm._v(" "), (_vm.isUserAuthToCrud) ? _c('v-row', {
    staticClass: "mt-1 speed-dial-elem-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "align-self-center"
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "fab": "",
      "small": "",
      "activeClass": "menuLink"
    },
    on: {
      "click": _vm.clickOrganizationHomeBtn
    }
  }, [_c('v-icon', [_vm._v("dashboard")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "align-self-center"
  }, [_c('div', {
    staticClass: "px-4 py-3 speed-dialog-label-div",
    on: {
      "click": _vm.clickOrganizationHomeBtn
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$t('Toolbar.dashboard')))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isUserAuthToReports) ? _c('v-row', {
    staticClass: "mt-1 speed-dial-elem-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "align-self-center"
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "fab": "",
      "small": "",
      "activeClass": "menuLink"
    },
    on: {
      "click": _vm.clickReportsBtn
    }
  }, [_c('v-icon', [_vm._v("analytics")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "align-self-center"
  }, [_c('div', {
    staticClass: "px-4 py-3 speed-dialog-label-div",
    on: {
      "click": _vm.clickReportsBtn
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$t('Toolbar.reports')))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isUserAuthToAudits) ? _c('v-row', {
    staticClass: "mt-1 speed-dial-elem-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "align-self-center"
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "fab": "",
      "small": "",
      "activeClass": "menuLink"
    },
    on: {
      "click": _vm.clickAuditsBtn
    }
  }, [_c('v-icon', [_vm._v("mdi-clipboard-check-outline")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "align-self-center"
  }, [_c('div', {
    staticClass: "px-4 py-3 speed-dialog-label-div",
    on: {
      "click": _vm.clickAuditsBtn
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$t('Toolbar.audits')))])])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-avatar', {
    attrs: {
      "size": "40"
    }
  }, [_c('img', {
    staticClass: "fill-height",
    attrs: {
      "src": require('../../assets/logoPonce.png'),
      "alt": _vm.$t('Toolbar.profilePic')
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('ImpersonateBtn'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "BtnAccount ma-0 my-3",
          attrs: {
            "small": "",
            "fab": "",
            "text": ""
          },
          model: {
            value: (_vm.dialMenu),
            callback: function($$v) {
              _vm.dialMenu = $$v
            },
            expression: "dialMenu"
          }
        }, on), [_c('v-avatar', {
          attrs: {
            "size": "40"
          }
        }, [_c('img', {
          staticClass: "profile-img",
          attrs: {
            "src": _vm.userProfilePic
          }
        })])], 1)]
      }
    }], null, false, 1235310641)
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.onLogout()
      }
    }
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Toolbar.logout')))])], 1)], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e12c272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Toolbar.vue
// module id = 886
// module chunks = 0 1